module.exports = __webpack_public_path__ + "img/game-feature2.35a67aa7.png";